import { ApiService } from '../../@graphql/services/api.service';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {
  GET_CITIES_BYCOMPANY,
  GET_ACTIVITIES_BYCITY,
  GET_SINGLE_ACTIVITY,
  SEARCH_ACTIVITIES_BY_CITY,
  GET_ICA_BASES_BY_CITY,
  GET_TYPES,
} from '../../@graphql/operations/query';
import { map } from 'rxjs/internal/operators/map';
import {
  CREATE_ACTIVITY,
  UPDATE_ACTIVITY,
  CREATE_ICA_BASE,
  UPDATE_ICA_BASE,
} from '../../@graphql/operations/mutation';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';

@Injectable({
  providedIn: 'root',
})
export class TributaryService extends ApiService {
  constructor(
    apollo: Apollo,
    private cookieAuthService: CookieAuthService,
  ) {
    super(apollo);
  }

  getSingleActivity(id_activity: number) {
    return this.query(GET_SINGLE_ACTIVITY, { id_activity: id_activity }).pipe(
      map((result: any) => {
        return result.getSingleActivity;
      }),
    );
  }

  getCitiesByCompany(id_country: number) {
    return this.query(GET_CITIES_BYCOMPANY, { id_country: id_country }).pipe(
      map((result: any) => {
        return result.getCitiesByCountry;
      }),
    );
  }

  getActivitiesByCity(id_city: number) {
    return this.query(GET_ACTIVITIES_BYCITY, { id_city: id_city }).pipe(
      map((result: any) => {
        return result.getActivitiesByCity;
      }),
    );
  }

  searchActivitiesByCity(
    id_city: number | null,
    value: string,
    page: number,
    size: number,
  ) {
    return this.query(SEARCH_ACTIVITIES_BY_CITY, {
      id_city,
      value,
      page,
      size,
    }).pipe(
      map((result: any) => {
        return result.searchActivitiesByCity;
      }),
    );
  }

  createActivity(
    id_city: number,
    ica_code: string,
    activity_code: string,
    activity_description: string,
    actual_rate: number,
  ) {
    return this.mutation(CREATE_ACTIVITY, {
      id_city: id_city,
      ica_code: ica_code,
      activity_code: activity_code,
      activity_description: activity_description,
      actual_rate: actual_rate,
    }).pipe(
      map((result: any) => {
        return result.createActivity;
      }),
    );
  }

  modifyActivity(
    id_activity: number,
    id_city: number,
    ica_code: string,
    activity_code: string,
    activity_description: string,
    actual_rate: number,
  ) {
    return this.mutation(UPDATE_ACTIVITY, {
      id_activity: id_activity,
      id_city: id_city,
      ica_code: ica_code,
      activity_code: activity_code,
      activity_description: activity_description,
      actual_rate: actual_rate,
    }).pipe(
      map((result: any) => {
        return result.updateActivity;
      }),
    );
  }

  getIcaBasesByCity(city: string) {
    const companyObject = this.cookieAuthService.getCompanyObject;
    const company = companyObject?.Id_company;
    return this.query(GET_ICA_BASES_BY_CITY, { company, city }).pipe(
      map((result: any) => result.getIcaBasesByCity),
    );
  }

  createIcaBase(id_city: number, id_type: number, uvt: number) {
    const companyObject = this.cookieAuthService.getCompanyObject;
    const company = companyObject?.Id_company;
    return this.mutation(CREATE_ICA_BASE, {
      company,
      id_city: Number(id_city),
      id_type: Number(id_type),
      uvt: Number(uvt),
    }).pipe(map((result: any) => result.createIcaBase));
  }

  updateIcaBase(id_ica_base: number, uvt: number) {
    const companyObject = this.cookieAuthService.getCompanyObject;
    const company = companyObject?.Id_company;
    return this.mutation(UPDATE_ICA_BASE, {
      company,
      id_ica_base: Number(id_ica_base),
      uvt: Number(uvt),
    }).pipe(map((result: any) => result.updateIcaBase));
  }

  getAllTypes() {
    const companyObject = this.cookieAuthService.getCompanyObject;
    const company = companyObject?.Id_company;
    return this.query(GET_TYPES, { company }).pipe(
      map((result: any) => result.getAllTypes),
    );
  }
}
